import { z } from 'zod';
import { TimestampSchema, UuidSchema } from './primitives';

/**
 * `audit_log` row — append-only. Sensitive fields (bodies, IPs, user-agents)
 * are stored as hashes only (sha256 hex) so we can prove "same actor / same
 * payload" without retaining PII. See SAZEO_V2_ANATOMY.md §5.3.
 */
export const AuditLogEntrySchema = z.object({
  id: UuidSchema,
  tenant_id: UuidSchema.nullable(),
  actor_user_id: UuidSchema.nullable(),
  action: z.string().min(1).max(120),
  entity_type: z.string().min(1).max(80),
  entity_id: UuidSchema.nullable(),
  before_hash: z.string().length(64).nullable(),
  after_hash: z.string().length(64).nullable(),
  ip_hash: z.string().length(64).nullable(),
  user_agent_hash: z.string().length(64).nullable(),
  ts: TimestampSchema,
});
export type AuditLogEntry = z.infer<typeof AuditLogEntrySchema>;
